import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import {
  useGetClaimById,
  useInsertClaimMutation,
  useUpdateClaimMutation,
} from "AppQuries/claim/claim-management";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { Pdf } from "core/img/imagePath";
const EditClaim = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();

  const {
    data: claimData,
    isLoading,
    isError: isGettingError,
    error: gettingError,
  } = useGetClaimById({
    companyCode: userData.companyCode,
    code: code,
  });
  const {
    mutate: updateClaim,
    isPending,
    isError,
    error,
  } = useUpdateClaimMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(addClaimValidation),
  });

  const navigate = useNavigate();

  const { setValue, handleSubmit } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    payload.isApproval = Number(payload.isApproval);
    updateClaim(payload, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          toast.success("Claim Updated Successfully.");

          setTimeout(() => {
            navigate(`${all_routes.claim}${all_routes.claim_list}`);
          }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const [isSettingData, setIsSettingData] = useState(true);
  useEffect(() => {
    if (Array.isArray(claimData)) {
      Object.keys(claimData[0]).forEach((key) => {
        setValue(key, claimData[0][key]);
      });
    }
    setIsSettingData(false);
  }, [claimData]);
  if (isError) return <Error404 error={error} />;
  if (isGettingError) return <Error404 error={gettingError} />;
  if (isLoading || isSettingData) return <LoadingSpinner />;

  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Claim Management</h4>
                    <h6>Update your claim </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="back">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.claim}${all_routes.claim_list}`}
                      className="btn btn-secondary"
                    >
                      {/* <ArrowLeft className="me-2" /> */}
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update Claim Data</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Claims</h4>
                    </div>
                    <div className="card-body">
                      <ClaimForm />

                      {claimData?.[0]?.claimAttachments?.length > 0 && (
                        <div className="card row m-5 border-0">
                          <div className="card-header">
                            <h4 className="card-title text-center">
                              Attached Images
                            </h4>
                          </div>
                          <div className="card-body">
                            <div className="d-flex ">
                              {claimData?.[0]?.claimAttachments?.map(
                                (item, index) => (
                                  <ImagePreview
                                    src={item?.attachment}
                                    alt="Attachment Image"
                                    className="img-fluid"
                                    key={index}
                                    style={{
                                      marginRight: "10px",
                                      width: "100px",
                                      height: "100px",
                                    }}
                                  />
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {claimData?.[0]?.claimPdfAttachments?.length > 0 && (
                        <div className="card row m-5 border-0">
                          <div className="card-header">
                            <h4 className="card-title text-center">
                              Attached Pdf
                            </h4>
                          </div>
                          <div className="card-body">
                            <div className="d-flex">
                              {claimData?.[0]?.claimPdfAttachments?.map(
                                (item, index) => (
                                  <ImagePreview
                                    src={Pdf}
                                    alt="Attachment Image"
                                    className="img-fluid"
                                    key={index}
                                    onClick={() =>
                                      window.open(item?.pdfAttachment, "_blank")
                                    }
                                    style={{
                                      marginRight: "10px",
                                      width: "100px",
                                      height: "100px",
                                    }}
                                  />
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditClaim;
